(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ptd-home-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ptd-home-carousel')) {
  customElements.define('ptd-home-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.controls = this.querySelector('[data-controls]');
      this.rotation = this.querySelector('[data-rotation]');
      if (!this.track || !this.previous || !this.next) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.loop = this.hasAttribute('data-loop');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches;
      this.inView = false;
      this.hovered = false;
      this.focused = false;
      this.previous.addEventListener('click', () => { this.move(-1); this.startTimer(); }, options);
      this.next.addEventListener('click', () => { this.move(1); this.startTimer(); }, options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        if (this.track.scrollWidth <= this.track.clientWidth + 2) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      if (this.dataset.autoplay === 'true') {
        this.rotation?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.rotationLabel();
          this.startTimer();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.startTimer(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.startTimer(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.startTimer(); }, options);
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.startTimer();
        }, options);
        document.addEventListener('visibilitychange', () => this.startTimer(), options);
        this.motion.addEventListener('change', event => {
          if (event.matches) this.userPaused = true;
          this.rotationLabel(); this.startTimer();
        }, options);
        this.visibility = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting; this.startTimer();
        }, { threshold: 0.25 });
        this.visibility.observe(this);
        this.rotationLabel();
      }
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.visibility?.disconnect();
      clearInterval(this.timer);
    }
    startTimer() {
      clearInterval(this.timer);
      if (this.dataset.autoplay !== 'true' || this.userPaused || this.hovered || this.focused || !this.inView || document.hidden) return;
      this.timer = setInterval(() => this.move(1), Math.max(5000, Number(this.dataset.interval) || 7000));
    }
    rotationLabel() {
      if (!this.rotation) return;
      const label = this.userPaused ? this.rotation.dataset.labelPlay : this.rotation.dataset.labelPause;
      this.rotation.setAttribute('aria-label', label);
      this.rotation.textContent = this.userPaused ? '▶' : 'Ⅱ';
    }
    move(direction) {
      const card = this.track.querySelector('[data-slide]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      const max = this.track.scrollWidth - this.track.clientWidth;
      let left = this.track.scrollLeft + step * direction;
      if (this.loop && left > max + 3) left = 0;
      if (this.loop && left < -3) left = max;
      this.track.scrollTo({ left, behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = Math.abs(this.track.scrollLeft);
      this.controls.hidden = max < 3;
      this.previous.disabled = !this.loop && left < 3;
      this.next.disabled = !this.loop && left >= max - 3;
      const counter = this.querySelector('[data-counter]');
      if (counter) counter.textContent = (Math.round(left / Math.max(this.track.clientWidth, 1)) + 1) + ' / ' + this.track.querySelectorAll('[data-slide]').length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
